import React from 'react';
import { connect } from 'react-redux';
import {
  Element,
  Color,
  FontType,
  Typography
} from '@americanexpress/aqx-components';
import { getPageData } from 'src/universal/redux/page';

import styles from './__styles__/index.scss?modules';

const CorpVacHero = ({ corpVacData }) => {
  if (!corpVacData) {
    return null;
  }
  const { title, header, description, cta, assets } = corpVacData;
  return (
    <Element className={styles.corpVacHero} theme={{ bgColor: Color.BrightBlue }}>
      <Element className={styles.leftText}>
        <Typography
          $family={FontType.HelveticaBold}
          $size="16px"
          $lineHeight="24px"
          Component="h1"
          theme={{ color: Color.White, marginBottom: 10 }}
        >
          {title}
        </Typography>
        <Typography
          $family={FontType.BentonLight}
          $size="30px"
          $lineHeight="38px"
          theme={{ color: Color.White, marginBottom: 10 }}
        >
          {header}
        </Typography>
        <Typography
          $family={FontType.HelveticaRegular}
          $size="16px"
          $lineHeight="24px"
          theme={{ color: Color.White, marginBottom: 10 }}
        >
          {description}
        </Typography>
        <Typography
          $family={FontType.HelveticaBold}
          $size="15px"
          $lineHeight="22px"
          theme={{ color: Color.White }}
        >
          {cta}
        </Typography>
        <Element className={styles.heroCardArtImage}>
          <img src={assets[1]?.url} alt={assets[1]?.alt} />
        </Element>
      </Element>
      <Element className={styles.heroImage}>
        <img src={assets[0]?.url} alt={assets[0]?.alt} />
      </Element>
    </Element>
  );
};

const mapStateToProps = state => {
  const pageData = getPageData(state);
  return {
    corpVacData: pageData.corpVacHero
  };
};

export default connect(mapStateToProps)(CorpVacHero);
